import axiosInstance from "../tokenInterceptor/AxiosInstance";

export class SubscriberService {
  constructor() {
    this.Api = "subscriber";
  }

  subscribe(subscriberData) {
    return axiosInstance.post(`${this.Api}/subscribe`, subscriberData);
  }
}

export default SubscriberService;
